import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { ChevronLeftIcon, ChevronRightIcon } from '@beef/ui-kit';
import { Picture } from "../../../Picture";
import { DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON } from "../../../../constants/device";
import { Carousel } from "../../../Carousel";
import style from "./styles.module.pcss";
var cx = classNames.bind(style);
var FALLBACK_PICTURE_LINK = 'https://static.beeline.ru/upload/images/error-content-sky.png';
var getIsCarousel = function getIsCarousel(length, size) {
  var isLarge = size === 'xl' || size === 'l';
  var isMedium = size === 'm';
  return length > DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON.L && isLarge || length > DEVICE_COUNT_PICTURES_TO_RENDER_BUTTON.M && isMedium;
};
export var Gallery = function Gallery(_ref) {
  var pictures = _ref.pictures,
    size = _ref.size,
    sliderDirection = _ref.sliderDirection,
    control = _ref.control;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    picture = _useState2[0],
    setPicture = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    errorPictures = _useState4[0],
    setErrorPictures = _useState4[1];
  var prevRef = useRef(null);
  var nextRef = useRef(null);
  var onErrorLoadCarouselPicture = useCallback(function (src) {
    return function () {
      setErrorPictures(function (prev) {
        return [].concat(_toConsumableArray(prev), [src]);
      });
    };
  }, []);
  useEffect(function () {
    if (pictures.length > 0) {
      setPicture(pictures[0]);
    }
  }, [pictures]);
  var isControlScrolling = useMemo(function () {
    return getIsCarousel(pictures.length, size);
  }, [pictures, size]);
  return pictures.length ? /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', {
      'wrapper--vertical': sliderDirection === 'vertical',
      'wrapper--small': pictures.length < 4
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('img-wrapper', {
      'img-wrapper--xl': size === 'xl',
      'img-wrapper--m': size === 'm',
      'img-wrapper--error': errorPictures.includes(picture === null || picture === void 0 ? void 0 : picture.src)
    })
  }, control, /*#__PURE__*/React.createElement(Picture, _extends({}, picture, {
    fallbackSrc: FALLBACK_PICTURE_LINK,
    lazy: false,
    src: picture === null || picture === void 0 ? void 0 : picture.src
  }))), pictures.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: cx('gallery-wrapper', {
      'gallery-wrapper--vertical': sliderDirection === 'vertical',
      'gallery-wrapper--m': size === 'm'
    })
  }, isControlScrolling && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    className: cx('gallery-button', 'prev-wrapper', {
      'prev-wrapper--vertical': sliderDirection === 'vertical'
    }),
    ref: prevRef,
    type: "button"
  }, /*#__PURE__*/React.createElement(ChevronLeftIcon, null)), /*#__PURE__*/React.createElement("button", {
    className: cx('gallery-button', 'next-wrapper', {
      'next-wrapper--vertical': sliderDirection === 'vertical'
    }),
    ref: nextRef,
    type: "button"
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, null))), /*#__PURE__*/React.createElement(Carousel, {
    className: cx('swiper', {
      'swiper--vertical': sliderDirection === 'vertical',
      'swiper--vertical__less-three-item': pictures.length === 3,
      'swiper--width-three': pictures.length === 3,
      'swiper--width-two': pictures.length === 2
    }),
    paginatePadding: false,
    settings: {
      enabled: isControlScrolling,
      onBeforeInit: function onBeforeInit(swiper) {
        swiper.params.navigation.prevEl = prevRef.current;
        swiper.params.navigation.nextEl = nextRef.current;
      },
      onSlideChange: function onSlideChange(swiper) {
        setPicture(pictures[swiper === null || swiper === void 0 ? void 0 : swiper.realIndex]);
      },
      slidesPerView: pictures.length < 4 ? pictures.length : 4,
      direction: sliderDirection,
      loop: pictures.length >= 4
    }
  }, pictures.map(function (galleryPicture) {
    return /*#__PURE__*/React.createElement("button", {
      className: cx('gallery-img-wrapper', {
        'gallery-img-wrapper--selected': galleryPicture.src === (picture === null || picture === void 0 ? void 0 : picture.src)
      }),
      key: galleryPicture.src,
      onClick: function onClick() {
        return setPicture(galleryPicture);
      },
      type: "button"
    }, /*#__PURE__*/React.createElement(Picture, _extends({}, galleryPicture, {
      fallbackSrc: FALLBACK_PICTURE_LINK,
      onError: onErrorLoadCarouselPicture(galleryPicture.src),
      src: galleryPicture.src
    })));
  })))) : null;
};